"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withGuidesProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const GuidesProvider_1 = require("./GuidesProvider");
const withGuidesProvider = (Component) => {
    const WrappedComponent = props => ((0, jsx_runtime_1.jsx)(GuidesProvider_1.GuidesProvider, { "data-e2e": 'GuidesProvider', children: (0, jsx_runtime_1.jsx)(Component, Object.assign({}, props, { "data-e2e": 'Component' })) }));
    return WrappedComponent;
};
exports.withGuidesProvider = withGuidesProvider;
